import { render, staticRenderFns } from "./DeactivatedDialog.vue?vue&type=template&id=2743f970&scoped=true&"
import script from "./DeactivatedDialog.vue?vue&type=script&lang=js&"
export * from "./DeactivatedDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeactivatedDialog.vue?vue&type=style&index=0&id=2743f970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743f970",
  null
  
)

export default component.exports